import { TFeeType } from './group.interface';
export enum EBankKeys {
  paymentsResume = 'paymentsResume',
  pendingPayments = 'pendingPayments',
  socialProjects = 'socialProjects',
  tpvUrl = 'tpvUrl',
  liliSocialBank = 'liliSocialBank',
}

export type TBankKeys =
  | EBankKeys.paymentsResume
  | EBankKeys.pendingPayments
  | EBankKeys.socialProjects
  | EBankKeys.tpvUrl
  | EBankKeys.liliSocialBank;

export interface IBankPendingPayment {
  id: string;
  group: {
    id: number | string;
    name: string;
    payLimitDate: string;
    createdAt?: string;
    updatedAt?: string;
    isClosed?: boolean;
    isUsedMoneybox?: boolean;
  };
  amount?: number;
  feeType?: TFeeType;
  paid: boolean;
}

export interface IBankPaymentResume {
  groupName: string;
  paidFor?: string;
  amount: number;
  date: string;
  pendingPayment: IBankPendingPayment;
}

export interface IBankSocialProject {
  groupName: string;
  amount: number;
  date: string;
  paidFor?: string;
}

export interface ILiliSocialBank {
  amount: number | undefined;
  donationDate: string;
}

export interface IBank {
  [EBankKeys.paymentsResume]: IBankPaymentResume[];
  [EBankKeys.pendingPayments]: IBankPendingPayment[];
  [EBankKeys.socialProjects]: any;
  [EBankKeys.tpvUrl]: string;
  [EBankKeys.liliSocialBank]: ILiliSocialBank | undefined;
}
